import { tv } from 'tailwind-variants'

const styles = tv({
  slots: {
    wrapper: 'text-[52px] font-bold'
  }
})

export default styles
